import React from 'react';
import PropTypes from 'prop-types';
import { getChipCount, getFilterLabels } from './filterHelpers.js';
import ExpansionPanel from '../ExpansionPanel/ExpansionPanel.js';
import SingleCompoundFilter from './SingleCompoundFilter.js';
import { useNameConventions } from '../../../contexts/nameConventionsContext.js';
import { useUser } from '../../../contexts/userContext.js';

const CompoundFilter = ({
  setting,
  appliedFilters,
  innerAppliedFilters,
  setInnerAppliedFilters,
  filterLabelsParams,
  setRefresh,
  index
}) => {
  const { nameConventions } = useNameConventions();
  const { costModel } = useUser();
  const chipCount = getChipCount(setting.options, appliedFilters.find(x => x.type === setting.type)?.options || [], 'name', 'abbreviation');

  return (
    <ExpansionPanel
      titleClasses="filter-expansion-panel-title forge-typography--heading2"
      iconClasses="filter-expansion-panel-icon-container"
      title={getFilterLabels(setting.type, filterLabelsParams[setting.type], nameConventions, costModel)}
      withCard={false}
      chipCount={chipCount}
      clearButton={chipCount > 0}
      handleClearButton={(e) => {
        e.stopPropagation();
        setInnerAppliedFilters(state => state.filter(filter => filter.type !== setting.type));
        setRefresh({});
      }}
      anchorId={`${setting.type}_${index}`}
    >
      {setting.options
        .map((setting) => {
          return {
            label: setting.abbreviation,
            value: setting.scoreOptions.map((x) => {
              return {
                label: x.name,
                value: x,
              };
            }),
            abbreviation: setting.abbreviation,
            id: setting.id,
          };
        })
        .map((option) => {
          return (
            <SingleCompoundFilter
              key={`${option.label}__${option.id}__${setting.type}`}
              option={option}
              setting={setting}
              innerAppliedFilters={innerAppliedFilters}
              setInnerAppliedFilters={setInnerAppliedFilters}
            />
          );
        })}
    </ExpansionPanel>
  );
};

CompoundFilter.propTypes = {
  setting: PropTypes.object,
  appliedFilters: PropTypes.array,
  innerAppliedFilters: PropTypes.array,
  setInnerAppliedFilters: PropTypes.func,
  filterLabelsParams: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  setRefresh: PropTypes.func,
  index: PropTypes.number
};

export default CompoundFilter;
